function Display({ displayState }) {
  return <input value={displayState} className="calculator-screen z-depth-1" disabled />
}

export default Display;
